// extracted by mini-css-extract-plugin
module.exports = {"size":"RecommendationShoesMeta_size__suqnW","container":"RecommendationShoesMeta_container__l3GWs","description":"RecommendationShoesMeta_description__sGJok"};